(function() {
  'use strict';

  // Check if config exists
  if (!window.iterableConfig) {
    return;
  }

  const config = window.iterableConfig;
  const FORM_ID = 'ContactPopup';
  const EMAIL_INPUT_ID = 'NewsletterFormPopup';

  // Helper function to capitalize first letter
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  function sendIterableSignup(emailInput, form) {
    const email = emailInput.value.trim();

    if (!email || !config.apiUrl || !config.apiKey) {
      return;
    }

    // Build siteID and source
    const siteID = `${config.brand}_${config.region}`.toUpperCase();
    const source = `${capitalizeFirstLetter(config.brand)}_popup`;

    // Use list endpoint if a list ID is provided
    const listId = form.querySelector('input[name="iterable_list_id"]')?.value;
    const useListEndpoint = Boolean(listId);

    // Build payload
    const payload = {
      requestType: useListEndpoint ? 'sendDataToIterableList' : 'sendDataToIterable',
      siteID: siteID,
      data: {
        email: email,
        country: config.countryName,
        countryCode: config.countryCode,
        source: source
      }
    };

    // Add listId if using list endpoint
    if (useListEndpoint) {
      payload.data.listId = listId;
    }

    // Fire-and-forget API call
    try {
      fetch(`${config.apiUrl}/admin-actions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': config.apiKey
        },
        body: JSON.stringify(payload)
      }).catch(err => {
        // Silent fail - don't block form submission
      });
    } catch (err) {
      // Silent fail - don't block form submission
    }
  }

  // Delegated submit handler catches forms injected after this script loads.
  document.addEventListener('submit', function(e) {
    const form = e.target;

    if (!(form instanceof HTMLFormElement) || form.id !== FORM_ID) {
      return;
    }

    e.preventDefault();

    const emailInput =
      form.querySelector(`#${EMAIL_INPUT_ID}`) ||
      document.getElementById(EMAIL_INPUT_ID);

    if (!emailInput) {
      return;
    }

    sendIterableSignup(emailInput, form);
  });
})();
